module.exports = __webpack_public_path__ + "img/register_bg.2135f485.png";